<div class="p-grid table-demo manage-product-section">
	<div class="p-col-12">
		<div class="card">
			<p-toast key="toastmsg"></p-toast>
			<h3>Ranking List</h3>
			<!-- <h5>Register Customer Account</h5> -->
			<p-toolbar styleClass="p-mb-4">
				<ng-template pTemplate="left">
					<button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2"
						icon="pi pi-filter-slash" (click)="clear()
					"></button>
				</ng-template>
				<ng-template pTemplate="right">

					<!-- <div class="new-search-container p-mr-2">
						<input type="text" placeholder="Search player" class="p-inputtext p-component p-element">
						<button class="searh-icon"><i class='bx bx-search'></i></button>
					</div> -->

					<button pButton pRipple label="Export" icon="pi pi-file-excel" (click)="exportExcel()"
						class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
					<!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
				</ng-template>
			</p-toolbar>

			<p-table class="p2-table-columns show-columns" #dt [value]="rankingList" [paginator]="true" [rows]="10"
				[lazy]="true" (onLazyLoad)="loadUsers($event)" [totalRecords]="totalRecords" [loading]="loading"
				[rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">

				<ng-template pTemplate="header" let-columns>
					<tr>
						<th pSortableColumn="rank" style="min-width: auto; width: 0px;">
							<div class="p-d-flex p-jc-between p-ai-center">
								Rank
								<p-sortIcon field="rank"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="ranking" style="min-width: 150px;">
							<div class="p-d-flex p-jc-between p-ai-center">
								Ranking
								<p-sortIcon field="ranking"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="ageGroup" style="min-width: 150px;">
							<div class="p-d-flex p-jc-between p-ai-center">
								Age Group
								<p-sortIcon field="ageGroup"></p-sortIcon>
							</div>
						</th>
                        <th pSortableColumn="points" style="min-width: 150px;">
							<div class="p-d-flex p-jc-between p-ai-center">
								Points
								<p-sortIcon field="points"></p-sortIcon>
							</div>
						</th>
                        <th pSortableColumn="matchType" style="min-width: 150px;">
							<div class="p-d-flex p-jc-between p-ai-center">
								Match Type
								<p-sortIcon field="matchType"></p-sortIcon>
							</div>
						</th>
					</tr>
					<tr>
						<th [ngSwitch]="rank">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'rank', 'contains')"
								[value]="dt.filters['rank'] ? dt.filters['rank'].value : ''" />
						</th>
						<th [ngSwitch]="ranking">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'ranking', 'contains')"
								[value]="dt.filters['ranking'] ? dt.filters['ranking'].value : ''" />
						</th>
						<th [ngSwitch]="ageGroup">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'ageGroup', 'contains')"
								[value]="dt.filters['ageGroup'] ? dt.filters['ageGroup'].value : ''" />
						</th>
                        <th [ngSwitch]="points">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'points', 'contains')"
								[value]="dt.filters['points'] ? dt.filters['points'].value : ''" />
						</th>
                        <th [ngSwitch]="matchType">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'matchType', 'contains')"
								[value]="dt.filters['matchType'] ? dt.filters['matchType'].value : ''" />
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-rank >
					<tr class="p-selectable-row" >
						<td>
							{{rank.rank}}
						</td>
						<td>
							{{rank.ranking}}
						</td>
						<td>
							{{rank.ageGroup}}
						</td>
						<td>
                            {{rank.points}}
						</td>
                        <td>
                            {{rank.matchType}}
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">No ranking list found.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="summary">
					<div class="p-d-flex p-ai-center p-jc-between">
						In total there are {{totalRecords }} ranking list.
					</div>
				</ng-template>
			</p-table>
		</div>
		<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
	</div>
</div>